import {createContext,useContext} from 'solid-js';

/*
	When in development or build should we proxy images from production rather than accessing them directly?
	Creating snapshots of posters requires proxying. Otherwise accessing them directly is OK, and faster.
*/

const ProxyContext = createContext();

export function ProxyProductionImagesProvider(props)
{
	return (
		<ProxyContext.Provider value={true}>
			{props.children}
		</ProxyContext.Provider>
	);
}

export function useProxyProductionImages(): boolean
{
	return useContext(ProxyContext) ?? false;
}

